import { Theme } from '@mui/material'

const classes = {
  body1: (theme: Theme) => ({
    marginTop: theme.spacing(0.5),
  }),
}

export default classes
